import { useState } from 'react';

import useTranslations from '@/i18n/useTranslations';
import GoBackButton from '@/shared-components/buttons/components/GoBackButton';

import '../../artist-help/profile/styles.css';

export default function ProfileGalleryHelpUploadArtworksPage() {
  const t = useTranslations('galleries_help.upload_artworks');

  const highlightedSectionHeadingStyle = {
    color: 'var(--app-theme-color)',
    fontSize: 'var(--app-font-size-large)',
    marginBottom: '4px',
  };

  const [openSections, setOpenSections] = useState({
    guidelines: false,
    requirements: false,
    photography: false,
  });

  function toggleSection(sectionKey) {
    setOpenSections((previous) => ({
      ...previous,
      [sectionKey]: !previous[sectionKey],
    }));
  }

  return (
    <section className="artist-help-category gallery-help-category">
      <header className="artist-help-category__header gallery-help-category__header">
        <GoBackButton alternativeRoute="/profile/gallery-help" />
        <h1>{t('title')}</h1>
      </header>

      <div className="artist-help-category__body gallery-help-category__body">
        <section className="artist-help-category__card artist-help-category__accordion gallery-help-category__card gallery-help-category__accordion">
          <button
            type="button"
            className="artist-help-category__accordion-trigger gallery-help-category__accordion-trigger"
            onClick={() => toggleSection('guidelines')}
            aria-expanded={openSections.guidelines}
          >
            <h2>{t('sections.guidelines.title')}</h2>
            <span
              className={`artist-help-category__accordion-icon gallery-help-category__accordion-icon ${openSections.guidelines ? 'open' : ''}`}
              aria-hidden
            />
          </button>

          {openSections.guidelines && (
            <div className="artist-help-category__accordion-content gallery-help-category__accordion-content">
              <p>{t('sections.guidelines.intro_1')}</p>
              <p>{t('sections.guidelines.intro_2')}</p>

              <div className="artist-help-category__stack gallery-help-category__stack">
                <h3 style={highlightedSectionHeadingStyle}>{t('sections.guidelines.about_artwork.title')}</h3>
                <p>{t('sections.guidelines.about_artwork.p1')}</p>
              </div>

              <div className="artist-help-category__stack gallery-help-category__stack">
                <h3>{t('sections.guidelines.inventory_status.title')}</h3>
                <p>{t('sections.guidelines.inventory_status.p1')}</p>
                <p>{t('sections.guidelines.inventory_status.p2')}</p>
                <p>{t('sections.guidelines.inventory_status.p3')}</p>
              </div>

              <div className="artist-help-category__stack gallery-help-category__stack">
                <h3>{t('sections.guidelines.artists.title')}</h3>
                <p>{t('sections.guidelines.artists.p1')}</p>
                <p>{t('sections.guidelines.artists.p2')}</p>
              </div>

              <div className="artist-help-category__stack gallery-help-category__stack">
                <h3>{t('sections.guidelines.title_field.title')}</h3>
                <p>{t('sections.guidelines.title_field.p1')}</p>
              </div>

              <div className="artist-help-category__stack gallery-help-category__stack">
                <h3>{t('sections.guidelines.description.title')}</h3>
                <p>{t('sections.guidelines.description.p1')}</p>
              </div>

              <div className="artist-help-category__stack gallery-help-category__stack">
                <h3>{t('sections.guidelines.dimensions.title')}</h3>
                <p>{t('sections.guidelines.dimensions.p1')}</p>
              </div>

              <div className="artist-help-category__stack gallery-help-category__stack">
                <h3>{t('sections.guidelines.year_of_creation.title')}</h3>
                <p>{t('sections.guidelines.year_of_creation.p1')}</p>
              </div>

              <div className="artist-help-category__stack gallery-help-category__stack">
                <h3>{t('sections.guidelines.medium_materials.title')}</h3>
                <p>{t('sections.guidelines.medium_materials.p1')}</p>
              </div>

              <div className="artist-help-category__stack gallery-help-category__stack">
                <h3>{t('sections.guidelines.themes_feelings_colors.title')}</h3>
                <p>{t('sections.guidelines.themes_feelings_colors.p1')}</p>
              </div>

              <div className="artist-help-category__stack gallery-help-category__stack">
                <h3>{t('sections.guidelines.price.title')}</h3>
                <p>{t('sections.guidelines.price.p1')}</p>
                <p>{t('sections.guidelines.price.p2')}</p>
                <p>{t('sections.guidelines.price.p3')}</p>
              </div>

              <div className="artist-help-category__stack gallery-help-category__stack">
                <h3>{t('sections.guidelines.limited_editions.title')}</h3>
                <p>{t('sections.guidelines.limited_editions.p1')}</p>
                <p>{t('sections.guidelines.limited_editions.p2')}</p>
              </div>

              <div className="artist-help-category__stack gallery-help-category__stack">
                <h3 style={highlightedSectionHeadingStyle}>{t('sections.guidelines.media.title')}</h3>
                <p>{t('sections.guidelines.media.p1')}</p>

                <div className="artist-help-category__stack gallery-help-category__stack">
                  <h3>{t('sections.guidelines.media.main_picture.title')}</h3>
                  <p>{t('sections.guidelines.media.main_picture.p1')}</p>
                  <p>{t('sections.guidelines.media.main_picture.p2')}</p>
                </div>

                <div className="artist-help-category__stack gallery-help-category__stack">
                  <h3>{t('sections.guidelines.media.secondary_pictures.title')}</h3>
                  <p>{t('sections.guidelines.media.secondary_pictures.p1')}</p>
                  <p>{t('sections.guidelines.media.secondary_pictures.p2')}</p>
                </div>

                <div className="artist-help-category__stack gallery-help-category__stack">
                  <h3>{t('sections.guidelines.media.frame.title')}</h3>
                  <p>{t('sections.guidelines.media.frame.p1')}</p>
                </div>

                <div className="artist-help-category__stack gallery-help-category__stack">
                  <h3>{t('sections.guidelines.media.certificate_of_authenticity.title')}</h3>
                  <p>{t('sections.guidelines.media.certificate_of_authenticity.p1')}</p>
                </div>

                <div className="artist-help-category__stack gallery-help-category__stack">
                  <h3>{t('sections.guidelines.media.audio.title')}</h3>
                  <p>{t('sections.guidelines.media.audio.p1')}</p>
                  <p>{t('sections.guidelines.media.audio.p2')}</p>
                </div>
              </div>

              <div className="artist-help-category__stack gallery-help-category__stack">
                <h3 style={highlightedSectionHeadingStyle}>{t('sections.guidelines.shipping.title')}</h3>
                <p>{t('sections.guidelines.shipping.p1')}</p>
                <p>{t('sections.guidelines.shipping.p2')}</p>
                <p>{t('sections.guidelines.shipping.p3')}</p>
              </div>
            </div>
          )}
        </section>

        <section className="artist-help-category__card artist-help-category__accordion gallery-help-category__card gallery-help-category__accordion">
          <button
            type="button"
            className="artist-help-category__accordion-trigger gallery-help-category__accordion-trigger"
            onClick={() => toggleSection('requirements')}
            aria-expanded={openSections.requirements}
          >
            <h2>{t('sections.requirements.title')}</h2>
            <span
              className={`artist-help-category__accordion-icon gallery-help-category__accordion-icon ${openSections.requirements ? 'open' : ''}`}
              aria-hidden
            />
          </button>

          {openSections.requirements && (
            <div className="artist-help-category__accordion-content gallery-help-category__accordion-content">
              <p>{t('sections.requirements.intro')}</p>
              <ul>
                <li>
                  <strong>{t('sections.requirements.item_1_title')}</strong> {t('sections.requirements.item_1_body')}
                </li>
                <li>
                  <strong>{t('sections.requirements.item_2_title')}</strong> {t('sections.requirements.item_2_body')}
                </li>
                <li>
                  <strong>{t('sections.requirements.item_3_title')}</strong> {t('sections.requirements.item_3_body')}
                </li>
                <li>
                  <strong>{t('sections.requirements.item_4_title')}</strong> {t('sections.requirements.item_4_body')}
                </li>
              </ul>
              <p>
                {t('sections.requirements.support_intro')}{' '}
                <a href={`mailto:${t('sections.requirements.support_email')}`}>{t('sections.requirements.support_email')}</a>.
              </p>
            </div>
          )}
        </section>

        <section className="artist-help-category__card artist-help-category__accordion gallery-help-category__card gallery-help-category__accordion">
          <button
            type="button"
            className="artist-help-category__accordion-trigger gallery-help-category__accordion-trigger"
            onClick={() => toggleSection('photography')}
            aria-expanded={openSections.photography}
          >
            <h2>{t('sections.photography.title')}</h2>
            <span
              className={`artist-help-category__accordion-icon gallery-help-category__accordion-icon ${openSections.photography ? 'open' : ''}`}
              aria-hidden
            />
          </button>

          {openSections.photography && (
            <div className="artist-help-category__accordion-content gallery-help-category__accordion-content">
              <p>{t('sections.photography.intro')}</p>
              <ul>
                <li>
                  <strong>{t('sections.photography.item_1_title')}</strong> {t('sections.photography.item_1_body')}
                </li>
                <li>
                  <strong>{t('sections.photography.item_2_title')}</strong> {t('sections.photography.item_2_body')}
                </li>
                <li>
                  <strong>{t('sections.photography.item_3_title')}</strong> {t('sections.photography.item_3_body')}
                </li>
                <li>
                  <strong>{t('sections.photography.item_4_title')}</strong> {t('sections.photography.item_4_body')}
                </li>
                <li>
                  <strong>{t('sections.photography.item_5_title')}</strong> {t('sections.photography.item_5_body')}
                </li>
                <li>
                  <strong>{t('sections.photography.item_6_title')}</strong> {t('sections.photography.item_6_body')}
                </li>
              </ul>
              <p>{t('sections.photography.closing')}</p>
            </div>
          )}
        </section>
      </div>
    </section>
  );
}
